import { render, staticRenderFns } from "./Stations.vue?vue&type=template&id=5b8f1c53"
import script from "./Stations.vue?vue&type=script&lang=js"
export * from "./Stations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8f1c53')) {
      api.createRecord('5b8f1c53', component.options)
    } else {
      api.reload('5b8f1c53', component.options)
    }
    module.hot.accept("./Stations.vue?vue&type=template&id=5b8f1c53", function () {
      api.rerender('5b8f1c53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/Stations.vue"
export default component.exports